// let vendor_js_footer = [
//     paths.src.js + 'vendor/bootstrap.bundle.min.js',
//     paths.src.js + 'vendor/fancybox.umd.js'
// ];

// From inc/ directory
import "./inc/map_search.js";
import "./inc/read_more.js";
import "./inc/retail_user.js";

// Formerly in vendor.footer.js
import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper';
import { Fancybox } from "@fancyapps/ui";
import * as bootstrap from "bootstrap";

// oilib.js needs bootstrap to be available on the window object. It uses bootstrap popovers (maybe others, too).
window.bootstrap = bootstrap;
window.Swiper = Swiper;
Swiper.use([Autoplay, EffectFade, Navigation, Pagination]);

// =============================================================================
// get the sticky element
const stickyElm = document.querySelector('.main-navbar')

const observer = new IntersectionObserver(
  ([e]) => e.target.classList.toggle('stuck', e.intersectionRatio < 1),
  {threshold: [1]}
);

observer.observe(stickyElm)

// =============================================================================
// Trigger Tabs By Hash

var triggerTabList = [].slice.call(document.querySelectorAll(".tab-btn"));

triggerTabList.forEach(function (triggerEl) {
  var tabTrigger = new bootstrap.Tab(triggerEl);
  var hash = '#' + triggerEl.href.split("#")[1];
  var tabBtn = document.querySelector( hash + "-tab");

  triggerEl.addEventListener("click", function (event) {
    event.preventDefault();
    tabBtn.click();
  })
})

// =============================================================================
// Add Tooltips

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

// =============================================================================
// == Wrap Last Word In Span =============

function targetLastWord(element)
{
    var pieces = element.innerHTML.split(" ");
    var last = pieces.pop();
    var first = pieces.join(" ");
    element.innerHTML = first + '<span class="last-word"> ' + last + '</span>';
}

var lastWords =  document.querySelectorAll(".last-word-bold");
lastWords.forEach(x => targetLastWord(x));


// =============================================================================
// == Split String =============

function splitStringByBreak(element) {

    // Split the string into words
    var pieces = element.innerHTML.split(/<br\s*\/?>/, 2);
    var isAlreadySplit = element.getElementsByTagName('span');

    // Initialize arrays for the first and second halves
    var isTwoParts = pieces[1];
    var firstHalf = [];
    var secondHalf = [];

    if (isAlreadySplit.length == 0) {
        if(isTwoParts){
            var firstHalf = [pieces[0]];
            var secondHalf = [pieces[1]];

            // Join the halves back into strings
            var first = firstHalf.join(' ');
            var last = secondHalf.join(' ');

            element.innerHTML = '<span class="first-part"> ' + first + '</span><span class="second-part"> ' + last + '</span>';
        }
        else {
            var firstHalf = [pieces[0]];
            var first = firstHalf.join(' ');

            element.innerHTML = '<span class="second-part"> ' + first + '</span>';
        }
    }
}

var splitStrings = document.querySelectorAll(".split-string");
splitStrings.forEach(x => splitStringByBreak(x));

// =============================================================================
// == Focus on Search Open =============

const searchModal = document.getElementById('search-modal')
const searchInput = document.getElementById('modal-search')

searchModal.addEventListener('shown.bs.modal', () => {
    searchInput.focus()
})

// =============================================================================
// == Actual StickyNav Heights =============

    function updatePosition() {
        const mainNav = document.getElementById('site-nav');
        const subNav = document.getElementById('subnav');
        const filters = document.getElementById('filters');

        let stickyWNav = document.querySelectorAll('.sticky-w-nav');
        let stickyWSubnav = document.querySelectorAll('.sticky-w-subnav');
        let stickyWFilters = document.querySelectorAll('.sticky-w-filters');

        // Set the top position of each target element based on the height of the reference element
        stickyWNav.forEach(function(stickyItem) {
            if(mainNav){
                let mainNavHeight = mainNav.getBoundingClientRect().height;
                stickyItem.style.top = mainNavHeight + 'px';
            }
        });
        stickyWSubnav.forEach(function(stickyItem) {
            if(mainNav && subNav){
                let mainNavHeight = mainNav.getBoundingClientRect().height;
                let subNavHeight = subNav.clientHeight;
                stickyItem.style.top = mainNavHeight + subNavHeight + 'px';
            } else if(subNav) {
                let subNavHeight = subNav.clientHeight;
                stickyItem.style.top = mainNavHeight + subNavHeight + 'px';
            }
        });
        stickyWFilters.forEach(function(stickyItem) {
            if(mainNav && subNav && filters){
                let mainNavHeight = mainNav.getBoundingClientRect().height;
                let subNavHeight = subNav.clientHeight;
                let filtersHeight = filters.clientHeight;
                stickyItem.style.top = mainNavHeight + subNavHeight + filtersHeight + 'px';
            } else if(mainNav && filters){
                let mainNavHeight = mainNav.getBoundingClientRect().height;
                let filtersHeight = filters.clientHeight;
                stickyItem.style.top = mainNavHeight + filtersHeight + 'px';
            } else if(filters){
                let filtersHeight = filters.clientHeight;
                stickyItem.style.top = filtersHeight + 'px';
            }
        });

    }

    window.addEventListener('load', updatePosition);
    window.addEventListener('resize', updatePosition);

// =============================================================================

/*
 * FANCYBOX
 *
 * The new Fancybox v4 (non-jQuery) triggers a "done" event for up to three images when
 * the carousel is first initilaized. To avoid triggering 3 image view events on every
 * Fancybox initCarousel action, an imageview event is triggered on the initCarousel
 * event, but "done" events are then ignored for 1 second. After 1 second, image view
 * events will be triggered as typical.
 */

// Tracks fancybox image views.
let fancyboxEventBlock = false

// Abstracted event action handler
const doFancyboxOiEvent = (fancybox) => {
    let oi_event_name = false
    // Identify the proper event name. Use the first occurence from the possibilities
    // below.
    // 1. If a trigger element is available, use the value of data-oi-event-name when
    //    present. This is the most common scenario.
    // 2. If the Fancybox options object has oiEventName attribute, use the value. Event
    //    names are define this way when Fancybox assets are populated by a javascript
    //    array, and not DOM elements are available to place the data attribute.
    if (fancybox.options.$trigger
        && fancybox.options.$trigger.dataset
        && fancybox.options.$trigger.dataset.oiEventName) {
            oi_event_name = fancybox.options.$trigger.dataset.oiEventName
    }
    if (oi_event_name) {
        if ("undefined" != typeof window.dataLayer) {
            window.dataLayer.push({ event: oi_event_name });
        }
        if ("undefined" != typeof window.hfaDataLayer) {
            window.hfaDataLayer.push({ event: oi_event_name });
        }
    }
}

// Define Fancybox config
window.FANCYBOX_CONFIG = {
    on: {
        initCarousel: (fancybox) => {
            if(!fancyboxEventBlock) {
                // Block additional Fancybox events
                fancyboxEventBlock = true

                // Do Fancybox event
                doFancyboxOiEvent(fancybox)

                // Undo the event block after 1 second.
                setTimeout(() => {
                    fancyboxEventBlock = false
                }, 1000)
            }
        },
        done: (fancybox, slide) => {
            if(!fancyboxEventBlock) {
                // Do Fancybox event
                doFancyboxOiEvent(fancybox)
            }
        },
        destroy: () => {
            // Reset the block on Fancybox close.
            fancyboxEventBlock = false
        },
    },
}

// Bind actions to Fancybox events
Fancybox.bind("[data-fancybox]", FANCYBOX_CONFIG)

/* END FANCYBOX */

// This fires the oi.utils function that will wrap all iframes contained in WYSIWYG
// editors with appropriate oi-aspect classes.

window.addEventListener('load', function () {
  oi.utils.wrap_oi_aspect();
}, false);

/* Set up scroll padding*/
const siteNav = document.getElementById('site-nav');
const filters = document.getElementById('filters');
const subnav = document.getElementById('subnav-wrapper');
let scrollPadding = siteNav.getBoundingClientRect().height + 8;
if (filters) {
    scrollPadding += filters.getBoundingClientRect().height;
}
if (subnav) {
    scrollPadding += subnav.getBoundingClientRect().height;
}
document.documentElement.style.setProperty('--scroll-padding-top', `${scrollPadding}px`);

// Add backdrop when dropdown menu is opened
let dropdownToggles = document.querySelectorAll('.main-menu-dropdown');
let mainContent = document.getElementById('mainContent');

dropdownToggles.forEach(function (dropdownToggle) {
    dropdownToggle.addEventListener('show.bs.dropdown', event => {
        mainContent.classList.toggle("menu-backdrop");
    });
    dropdownToggle.addEventListener('hide.bs.dropdown', event => {
        mainContent.classList.toggle("menu-backdrop");
    })
});


document.addEventListener('DOMContentLoaded', () => {
    // Select all elements with the class 'animate-on-scroll'
    const scrollElements = document.querySelectorAll('.animated-content');

    // Options for the Intersection Observer
    const observerOptions = {
        root: null, // observe against the viewport
        rootMargin: '0px',
        threshold: 0.1 // triggers when 10% of the element is visible
    };

    // Callback function for the observer
    const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Add the 'is-visible' class when the element enters the viewport
                entry.target.classList.add('is-visible');
                // Optional: Stop observing the element after it has animated once
                observer.unobserve(entry.target);
            }
        });
    };

    // Create the Intersection Observer instance
    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Start observing all target elements
    scrollElements.forEach(element => {
        observer.observe(element);
    });
});